<template>
  <div style="margin: 10px 0px 0px 10px;" @mouseleave="focusItem=null">
    <v-toolbar flat dark color="info" @mouseover="focusItem=null">
      <v-dialog max-width="500px" v-model="dialog" persistent>
        <template v-slot:activator="{ on }">
          <label><strong>Tài Khoản </strong></label>
          <v-btn color="default" v-on="on" icon style="position: absolute; right: 10px; top: 8px;">
            <v-icon>add</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-toolbar color="primary" dark>
            <v-toolbar-title style="padding-left: 0px">
              {{ formTitle }}
            </v-toolbar-title>
          </v-toolbar>
          <v-btn
              @click="close"
              icon
              style="
                            position: absolute;
                            right: 10px;
                            top: 10px;
                            color: #fff;
                        "
          >
            <v-icon>cancel</v-icon>
          </v-btn>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                      v-model="editedItem.accountZaloName"
                      label="Tên tài khoản zalo"
                      v-validate="'required'"
                      name="name"
                      :error-messages="errors.first('accountZaloName')"
                      :data-vv-as="$t('Tên account zalo')"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="save">
              <v-icon dark left>save</v-icon>
              {{ $t("lang.common.save") }}
            </v-btn>
            <v-btn color="error" @click="close">
              <v-icon dark left>cancel</v-icon>
              {{ $t("lang.common.cancel") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>

    <v-data-table
        :headers="headers"
        :items="desserts"
        class="elevation-1 gru-table fixed-header"
        hide-actions
    >
      <template v-slot:headers="">
        <td style="padding-top: 10px;padding-bottom: 10px;" @mouseover="focusItem=-1">
          <a
              @click="onView({ accountZaloId: 0 })"
              href="javascript:window.location"
              style="text-decoration: none;"
              :class="getClass(0,{ accountZaloId: 0 })"
          >
            Tất cả
          </a>
        </td>
      </template>
      <template v-slot:items="props">
        <td @mouseover="focusItem=props.index">
          <a
              @click="onView(props.item)"
              href="javascript:window.location"
              style="text-decoration: none;"
              :class="getClass(props.index+1, props.item)"
          >
            {{ props.item.accountZaloName }}
          </a>
          <div style="float: right" v-if="props.index == focusItem">
            <v-icon icon color="primary" icon @click="editItem(props.item)">
              edit
            </v-icon>
            <v-icon icon color="red" @click="deleteConfirm(props.item)">
              delete
            </v-icon>
          </div>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import {message} from "../../../../services";
import axios from "axios";

export default {
  name: "PondTypeList",
  props: {
    defaultData: {
      accountZaloId: Array,
      default: () => [],
    },
  },
  data: () => ({
    dialog: false,
    headers: [
      {
        text: "Tên",
        align: "left",
        value: "name",
      },
    ],
    focusItem: null,
    activeItem: {accountZaloId: 0},
    desserts: [],
    editedIndex: -1,
    editedItem: {
      accountZaloName: "",
      isActive: 1,
    },
    defaultItem: {
      accountZaloName: "",
      isActive: 1,
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Thêm mới tài khoản zalo" : "Cập nhật";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    defaultData: function (value) {
      this.desserts = this.copyValue(value);
    },
  },

  created() {
  },

  methods: {
    getClass(index, item) {
      if (item != null && this.activeItem != null && item.accountZaloId == this.activeItem.accountZaloId) {
        return "activeItem";
      }
      if (this.focusItem == null) {
        return "";
      }
      if (this.focusItem + 1 == index) {
        return "activeItem";
      } else {
        return "";
      }
    },

    copyValue: function (value) {
      let ob = value.slice();
      return ob;
    },

    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      console.log(item);
      this.editedItem = {
        accountZaloId: item.accountZaloId,
        accountZaloName: item.accountZaloName,
        isActive: item.isActive,
      };
      this.dialog = true;
    },

    deleteConfirm(item) {
      confirm("Bạn có muốn xóa tài khoản zalo này?") &&
      axios.post(
          process.env.VUE_APP_API_URL + "/kidClassZalo/search?pageSize=10&page=1", {accountZaloId: item.accountZaloId}
      )
          .then(
              (data) => {
                if (data.items && data.items.length > 0) {
                  message.error("Tài khoản zalo này đang quản lý lớp, không được xóa!");
                } else {
                  this.deleteItem(item);
                }
              }
          );
    },
    deleteItem(item) {
      axios.post(process.env.VUE_APP_API_URL + "/kidAccountZalo/delete", item)
          .then(
              (data) => {
                if (data) {
                  message.success("Đã xóa");
                  this.close();
                  this.$emit("getPondType");
                } else {
                  message.error("Lỗi!");
                }
              },
              (error) => {
                console.log(error);
              }
          );
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      this.$validator.validate().then((valid) => {
        if (!valid) {
          message.error(this.$t("lang.common.validate_fail"));
          return;
        }
        axios
            .post(process.env.VUE_APP_API_URL + "/kidAccountZalo/save",
                this.editedItem
            )
            .then(
                (data) => {
                  if (data.success) {
                    message.success(
                        this.$t("lang.common.save_success")
                    );
                    this.close();
                    this.$emit("getPondType");
                  } else {
                    message.error(this.$t(data.description));
                  }
                },
                (error) => {
                  console.log(error);
                }
            );
      });
    },
    onView(item) {
      this.$emit("onView", item);
      this.activeItem = item;
    },
    getPondList(type = 0) {

      axios.post(
          process.env.VUE_APP_API_URL + "/kidClass/listClassByAccountZaloId?pageSize=10&page=1", {accountZaloId: type}
      )
          .then(
              (data) => {

                if (data.items) {
                  return data.items;
                }
              }
          );
    },
    uppercase() {
      this.editedItem.parentName = this.editedItem.parentName.toUpperCase();
    },
  },
};
</script>